module.exports = __webpack_public_path__ + "img/am.31036fb7.png";